import {
  getStore,
  getBlackoutDates,
  getHQStore,
  getStoreWithName, getBrandedTermsAndConditions,
} from "../../../api/services/storeService";
import { logger } from "../../../api/Logger";
import router from "../../../router";
import { getMessageTemplates } from "../../../api/services/MassageTemplateService.js";
import {
  defaultMobileColors,
  defaultDesktopColors,
} from "../../../api/constants/colors";
import { isStoreSelectionAtCheckout } from "../../../api/helpers/commonHelpers";
import { DetectMobile } from "../../../mixins/detectmobile";
import merge from "lodash.merge";
import { orderTypeHelper } from '../../../api/helpers/orderTypeHelper';
import { AppConfig } from "../../../../AppConfig";
import EventBus from "../../../event-bus";

export default {
  state: {
    storeDoc: null,
    showAlert: false,
    alertPayload: {
      title: null,
      body: null,
    },
    popoup:null,
    storeSelectionAtCheckout: false,
    selectedSubCompany: null,
    ViewConfig: {
      LogIn: false,
      PickUp: false,
      Delivery: false,
      DeliverToRoom: false,
      EatIn: false,
      HideAddressOnPickup: false,
      HideTrackingOrderForGuest: false,
      ImageCenterMode: false,
      UiColours: {
        Mobile: {},
        Desktop: {},
      },
    },
    selectedCompanyViewConfig: {
      PickUp: false,
      Delivery: false,
      DeliverToRoom: false,
      EatIn: false,
    },
    storeLoaded: false,
    loadingBarDone: false,
    isGift: false,
    HQDoc: null,
    ThankYouMsg: "",
    HQStore: null,
    MessageTemplates: {},
    availableLocales: [],
    selectedLocale: null,
    orderHistoryDic: [],
    mobileEmbededReturnUrl: "",
    isInCheckout: false,
    dineInDigitalDisplay: false,
    orderTypeModal: false,
    termsAndConditions: ""
  },
  mutations: {
    setMobileEmbededReturnUrl(state, payload) {
      state.mobileEmbededReturnUrl = payload;
    },
    setloadingBarDone(state, payload) {
      state.loadingBarDone = payload;
    },
    setIsInCkeckout(state, payload) {
      state.isInCheckout = payload;
    },
    setDineInDigitalDisplay(state, payload) {
      state.dineInDigitalDisplay = payload;
    },
    setSelectedSubCompany(state, payload) {
      state.selectedSubCompany = payload;
      var config = state.selectedSubCompany
        ? state.selectedSubCompany.ViewComponentConfigs
        : {};
      if (!config) config = {};
      var settings = {
        PickUp: config.PickUp || false,
        Delivery: config.Delivery || false,
        DeliverToRoom: config.DeliverToRoom || false,
        ChargeToRoomRadio: config.ChargeToRoomRadio === false ? false : true,
        EnableCashOnPickup: config.EnableCashOnPickup || false,
        EnableAlipayPayment: config.EnableAlipayPayment || false,
        EnableWechatPayment: config.EnableWechatPayment || false,
        EnableApplePayment: config.ApplePayEnabled || false,
        EnableGooglePayment: config.GooglePayEnabled || false,
        EatIn: config.EatIn || false,
        PayLaterOnly: config.PayLaterOnly || false,
        EatInPayLater: config.EatInPayLater || false,
        ShareCart: config.ShareCart || false,
      };
      state.selectedCompanyViewConfig = { ...settings };
    },
    setShowAlert(state, payload) {
      state.showAlert = payload;
    },
    setAlertPayload(state, payload) {
      state.alertPayload = payload;
    },
    setPopup(state,payload){
      state.popoup = payload;
    },
    setCurrentStoreDoc(state, payload) {
      state.storeDoc = payload;
      if(state.storeDoc)
      {
        var config = state.storeDoc.ViewComponentConfigs;
        if (isStoreSelectionAtCheckout(payload)) {
          state.storeSelectionAtCheckout = true;
        } else {
          state.storeSelectionAtCheckout = false;
        }
        InitViewConfig(state, config || {});
        const stripeKey = state && state.storeDoc && state.storeDoc.PaymentConfigEnvironment === 'Sandbox'
        ? AppConfig.stripeTestToken
        : AppConfig.stripeToken;
        EventBus.$emit('update-stripe-config', stripeKey);
      }

    },
    setHQDoc(state, payload) {
      state.HQDoc = payload;
    },
    setHQStore(state, payload) {
      state.HQStore = payload;
    },
    setStoreLoaded(state) {
      state.storeLoaded = true;
    },
    setStoreLoading(state) {
      state.storeLoaded = false;
    },
    setIsGift(state, payload) {
      state.isGift = payload;
    },
    addUserOrderHistory(state, payload) {
      if (state.orderHistoryDic.length > 100) state.orderHistoryDic.shift(); //Remove first element
      state.orderHistoryDic.push({
        key: state.storeDoc.ID,
        value: payload,
      });
    },
    addMessageTemplates(state, payload) {
      state.MessageTemplates[payload.id] = payload.value;
      if (payload.id.trim() === "OrderSuccessfulScreen") {
        state.ThankYouMsg = payload.value;
      }
    },
    clearMessageTemplates(state) {
      state.MessageTemplates = {};
      state.ThankYouMsg = "";
    },
    setAvailableLocales(state, payload) {
      state.availableLocales = payload;
      if (!state.selectedLocale) state.selectedLocale = payload[0];
    },
    setCurrentLocale(state, payload) {
      state.selectedLocale = payload;
    },
    //toggle order type modal
    setOrderTypeModalDisplay(state, value) {
      state.orderTypeModal = value;
    },
    setTermsAndConditions(state, payload) {
      state.termsAndConditions = payload;
    }
  },
  actions: {
    initStore({ commit, dispatch }, payload) {
      let storeId = payload.storeId ? payload.storeId : payload;
      dispatch(`filterCoupons`, storeId, {root:true});
      dispatch(`giftFilterCoupons`, storeId, {root:true});

      getStore(storeId).onSnapshot(
        function(doc) {
          if (doc.exists) {
            getBlackoutDates(storeId).onSnapshot(
              async function(amendment) {
                if (amendment.exists) {
                  const merged = merge(doc.data(), amendment.data());
                  commit("setCurrentStoreDoc", merged);
                  commit("setShowOverlay", false);
                } else {
                  commit("setCurrentStoreDoc", doc.data());
                  commit("setShowOverlay", false);
                }
              },
              function(reason) {
                logger.log(
                  reason.name,
                  reason.toString(),
                  router.currentRoute.fullPath,
                  logger.LogType.Error
                );
                commit("setCurrentStoreDoc", doc.data());
                commit("setShowOverlay", false);
              }
            );
            if (payload.callback) {
              payload.callback();
            }
          } else {
            router.replace("/pagenotfound");
          }
        },
        function(reason) {
          logger.log(
            reason.code,
            reason.message,
            router.currentRoute.fullPath,
            logger.LogType.Error
          );
          router.replace("/GeneralError");
        }
      );
    },
    initStoreWithName({ commit, dispatch }, payload) {
      getStoreWithName(payload).onSnapshot(
        function(doc) {
          if (doc.docs.length) {
            const storeId = doc.docs[0].id;
            dispatch(`filterCoupons`, storeId, {root:true});
            dispatch(`giftFilterCoupons`, storeId, {root:true});

            getBlackoutDates(storeId).onSnapshot(
              async function(amendment) {
                if (amendment.exists) {
                  const merged = merge(doc.docs[0].data(), amendment.data());
                  commit("setCurrentStoreDoc", merged);
                } else {
                  commit("setCurrentStoreDoc", doc.docs[0].data());
                }
              },
              function(reason) {
                logger.log(
                  reason.name,
                  reason.toString(),
                  router.currentRoute.fullPath,
                  logger.LogType.Error
                );
                commit("setCurrentStoreDoc", doc.docs[0].data());
              }
            );
          } else {
            router.replace("/notFoundPage");
          }
        },
        function(reason) {
          logger.log(
            reason.code,
            reason.message,
            router.currentRoute.fullPath,
            logger.LogType.Error
          );
          router.replace("/GeneralError");
        }
      );
    },
    async selectSubCompany({ commit, getters }, payload) {
      var res = null;
      let amendment = null;
      if (payload) {
        res = await getStore(payload).get();
        amendment = await getBlackoutDates(payload).get();
      } else {
        if (getters.getSelectedSubCompany) {
          res = await getStore(getters.getSelectedSubCompany.ID).get();
          amendment = await getBlackoutDates(getters.getSelectedSubCompany.ID).get();
        }
      }
      const endResult = !!res && !!amendment
        ? merge(res.data(), amendment.data())
        : (res
        ? res.data()
        : null);
      commit("setSelectedSubCompany", endResult);
    },
    async initHQDoc({ commit }) {
      let hq = null, amendment = null, foundHQ = false;
      try {
        hq = await getHQStore().get();
        foundHQ = true;
      } catch {
        console.log("IsHQ Permission not granted");
      }

      if(foundHQ) {
        try {
          if(hq.size >= 1) {
            const storeId = hq.docs[0].id;
            amendment = await getBlackoutDates(storeId).get();
            if (amendment) {
              const merged = merge(hq.docs[0].data(), amendment.data())
              commit("setHQDoc", merged);
            } else {
              commit("setHQDoc", hq.docs[0].data());
            }
          } else {
            commit("setHQDoc", null);
          }
        } catch {
          if (hq.size >= 1) commit("setHQDoc", hq.docs[0].data());
          else commit("setHQDoc", null);
        }
      }
    },
    async initTermsAndConditions({ commit }) {
        const termsAndConditions = await getBrandedTermsAndConditions().get();
        if(termsAndConditions.exists && termsAndConditions.data().TermsAndConditions) {
          commit("setTermsAndConditions", termsAndConditions.data().TermsAndConditions);
        }
    },
    initMessageTemplates({ commit }, payload) {
      commit("clearMessageTemplates");
      getMessageTemplates(payload).onSnapshot(
        function(data) {
          if (data.docs) {
            data.docs.forEach(function(doc) {
              commit("addMessageTemplates", {
                id: doc.id.trim(),
                value: doc.data().template,
              });
            });
          }
        },
        function(reason) {
          logger.log(
            reason.code,
            reason.message,
            router.currentRoute.fullPath,
            logger.LogType.Error
          );
        }
      );
    },
    raiseAlert({ commit }, payload) {
      commit('setAlertPayload', payload);
      commit('setShowAlert', true);
    },
  },
  getters: {
    getStripeKey(state) {
      const stripeKey = state && state.storeDoc && state.storeDoc.PaymentConfigEnvironment === 'Sandbox'
        ? AppConfig.stripeTestToken
        : AppConfig.stripeToken;
      return stripeKey
    },
    currencySign(state) {
      if (state && state.storeDoc && state.storeDoc.CurrencyLocaleName) {
        const locale = state.storeDoc.CurrencyLocaleName.toLowerCase();
        return locale == 'id-id' ? {
          symbol: 'Rp ',
          precision: 0
        } : '$';
      } else {
        return '$';
      }
    },
    storeSelectionAtCheckoutMode(state) {
      return state.storeSelectionAtCheckout;
    },
    getloadingBarDone(state) {
      return state.loadingBarDone;
    },
    getShowAlert(state) {
      return state.showAlert;
    },
    getAlertPayload(state) {
      return state.alertPayload;
    },
    getPopup(state){
      return state.popoup;
    },
    getSelectedSubCompany(state) {
      return state.selectedSubCompany;
    },
    selectedCompany(state) {
      if (state.storeSelectionAtCheckout && state.isInCheckout) {
        return state.selectedSubCompany || {};
      } else return state.storeDoc || {};
    },
    selectedCompanyViewConfig(state) {
      if (state.storeSelectionAtCheckout && state.isInCheckout) {
        return state.selectedCompanyViewConfig || {};
      } else return state.ViewConfig || {};
    },
    isDigitalDisplay(state, getters) {
      return (
        (!getters.selectedCompanyViewConfig.Delivery &&
          !getters.selectedCompanyViewConfig.PickUp &&
          !getters.selectedCompanyViewConfig.DeliverToRoom &&
          !getters.selectedCompanyViewConfig.EatIn) ||
        state.dineInDigitalDisplay & !getters.selectedCompanyViewConfig.EatIn
      );
    },
    getMobileEmbededReturnUrl(state) {
      return state.mobileEmbededReturnUrl;
    },
    selectedLocale(state) {
      return state.selectedLocale;
    },
    getAvailableLanguages(state) {
      return state.availableLocales.map((m) => {
        return {
          locale: m,
          name: m == "en" ? "English" : "中文",
        };
      });
    },
    getMessageTemplates(state) {
      return state.MessageTemplates;
    },
    getThankYouMessage(state) {
      return (
        state.ThankYouMsg ||
        "A request has been sent. Please check your email to see the status of your order."
      );
    },
    currentStoreDoc(state) {
      return state.storeDoc;
    },
    viewConfig(state) {
      return state.ViewConfig;
    },
    storeLoaded(state) {
      return state.storeLoaded;
    },
    isGift(state) {
      return state.isGift;
    },
    hqDoc(state) {
      return state.HQDoc;
    },
    HQStore(state) {
      return state.HQStore;
    },
    getRecentOrder: (state) => (productId) => {
      for (var i = state.orderHistoryDic.length - 1; i >= 0; i--) {
        if (state.orderHistoryDic[i].key == productId) {
          return state.orderHistoryDic[i].value;
        }
      }
    },
    getRecentOrders(state, payload) {
      var orders = [];
      for (var i = 0 - 1; i < state.orderHistoryDic.length; i++) {
        if (state.orderHistoryDic[i].key == payload) {
          orders.push(state.orderHistoryDic[i].value);
        }
      }
      return orders;
    },
    getApplyMultiCoupon() {
      //TODO: this part must be get from firebase.
      return false;
    },
    isInCheckout(state) {
      return state.isInCheckout;
    },
    deliveryTimeSlots(state, getters) {
      if (
        getters.selectedCompany &&
        getters.selectedCompany.DeliveryAreas &&
        getters.deliveryAddress &&
        getters.deliveryAddress.PostalCode &&
        getters.selectedCompany.DeliveryAreas.some(s => s.PostcodeFrom <= getters.deliveryAddress.PostalCode && s.PostcodeTo >= getters.deliveryAddress.PostalCode)
      ) {
        var timeSlots = getters.selectedCompany.DeliveryAreas.find(p => p.PostcodeFrom <= getters.deliveryAddress.PostalCode && p.PostcodeTo >= getters.deliveryAddress.PostalCode).TimeSlots;
        return timeSlots ? timeSlots : null;
      }
      return null;
    },
    isDeliveryTimeSlotsEnable(state, getters) {
      if (
        getters.selectedCompany &&
        getters.selectedCompany.DeliveryAreas
      ) {
        return getters.selectedCompany.DeliveryAreas.some(s => s.TimeSlots && s.TimeSlots.length > 0);
      }
      return false;
    },

    // check if modal is visible
    getOrderTypeModalDisplay: (state) => {
      return state.orderTypeModal;
    },
    showNewUi(state) {
      return state.ViewConfig.IsNewUi;
    },
    showSharedCart: (state) => {
      return state.ViewConfig.ShareCart && orderTypeHelper.isDineIn();
    },

    getTermsAndConditions(state) {
      return state.termsAndConditions;
    }
  },
};

function InitViewConfig(state, config) {
  var settings = {
    ShowNotes: config.ShowNotes || false,
    ShowNotesForItem: config.ShowNotesForItem || false,
    LogIn: config.LogIn || false,
    PickUp: config.PickUp || false,
    Delivery: config.Delivery || false,
    DeliverToRoom: config.DeliverToRoom || false,
    ChargeToRoomRadio: config.ChargeToRoomRadio === false ? false : true,
    EnableCashOnPickup: config.EnableCashOnPickup || false,
    EnableAlipayPayment: config.EnableAlipayPayment || false,
    EnableWechatPayment: config.EnableWechatPayment || false,
    EnableApplePayment: config.ApplePayEnabled || false,
    EnableGooglePayment: config.GooglePayEnabled || false,
    EatIn: config.EatIn || false,
    HideAddressOnPickup: config.HideAddressOnPickup || false,
    HideTrackingOrderForGuest: config.HideTrackingOrderForGuest || false,
    ImageCenterMode: config.ImageCenterMode || false,
    FacebookLogin: config.FacebookLogin != false,
    GoogleLogin: config.GoogleLogin != false,
    IsHideCheckboxMarketing: config.IsHideCheckboxMarketing || false,
    PayLaterOnly: config.PayLaterOnly || false,
    EatInPayLater: config.EatInPayLater || false,
    ShareCart: config.ShareCart || false,
  };
  if (!config.UiColours) {
    config.UiColours = {
      Mobile: {},
      Desktop: {},
    };
  }
  var colors = state.ViewConfig.UiColours;
  var mobileAgent = DetectMobile.methods.isMobile();

  if (mobileAgent) {
    config.UiColours.Mobile = config.UiColours.Mobile || {};
    var mobile = config.UiColours.Mobile;
    if (mobile) {
      colors.Mobile = {
        ButtonColour: mobile.ButtonColour || defaultMobileColors.ButtonColour,
        ButtonText: mobile.ButtonText || defaultMobileColors.ButtonText,
        CommonColor: mobile.CommonColour || defaultMobileColors.CommonColor,
        MenuHighlight:
          mobile.MenuHighlight || defaultMobileColors.MenuHighlight,
        MenuHighlightedText:
          mobile.MenuHighlightText || defaultMobileColors.MenuHighlightedText,
        StatusPending:
          mobile.StatusPending || defaultMobileColors.StatusPending,
        TitleBar: mobile.TitleBar || defaultMobileColors.TitleBar,
        MenuBackground:
          mobile.MenuBackground || defaultMobileColors.MenuBackground,
        MenuText: mobile.MenuText || defaultMobileColors.MenuText,
        SplashScreenTextColor:
          mobile.HighlightTextColour || defaultMobileColors.HighlightTextColour,
      };
    }
  } else {
    config.UiColours.Desktop = config.UiColours.Desktop || {};
    var desktop = config.UiColours.Desktop;
    if (desktop) {
      colors.Desktop = {
        ButtonColour: desktop.ButtonColour || defaultDesktopColors.ButtonColour,
        ButtonText: desktop.ButtonText || defaultDesktopColors.ButtonText,
        CommonColor: desktop.CommonColour || defaultDesktopColors.CommonColor,
        MenuHighlight:
          desktop.MenuHighlight || defaultDesktopColors.MenuHighlight,
        MenuHighlightedText:
          desktop.MenuHighlightText || defaultDesktopColors.MenuHighlightedText,
        StatusPending:
          desktop.StatusPending || defaultDesktopColors.StatusPending,
        TitleBar: desktop.TitleBar || defaultDesktopColors.TitleBar,
        MenuBackground:
          desktop.MenuBackground || defaultDesktopColors.MenuBackground,
        MenuText: desktop.MenuText || defaultDesktopColors.MenuText,
        SplashScreenTextColor:
          desktop.HighlightTextColour || defaultMobileColors.HighlightTextColour,
      };
    }
  }
  state.ViewConfig = { ...state.ViewConfig, ...settings };
}
